import Image from "next/image"
import Card from "components/WideArticleCard"
import CallToAction from "./CallToAction"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import track from "utilities/track"

export default function CardAndBannerSection({
  bannerHeading,
  description,
  bannerContain,
  banner_cta_text,
  banner_cta_link,
  article,
  eyebrow,
  event_name,
}) {
  return (
    <section className="bg-gray-gradient">
      <div className="py-12 px-5">
        <div className="max-w-screen-xl mx-auto">
          <Card
            video={{ component: "yt_embed", id: article?.content?.video_id }}
            link={getStoryblokLink(article?.content?.link)}
            cta_text={article?.content?.cta_text}
            eyebrow={eyebrow}
            image={article?.content?.image}
            title={article?.content?.title}
            description={article?.content?.description}
          />
        </div>
      </div>

      <div className="red-banner xl:pb-10 text-white bg-red-gradient xl:relative px-5">
        <div className="max-w-screen-xl mx-auto">
          <div className="xl:relative">
            <Image
              src="/assets/banner.svg"
              className="hidden xl:block object-contain xl:object-cover overflow-x-visible"
              fill
              alt=""
              style={{ width: "100%" }}
            />
            <div className="p-4">
              <div className="flex flex-col lg:flex-row gap-2 lg:gap-8 lg:items-center lg:justify-between max-w-[850px] mx-auto z-10 relative">
                <div>
                  <h3 className="pb-2 text-white">{bannerHeading}</h3>
                  <p className="pb-4">{description}</p>
                </div>
                <div>
                  <CallToAction style="ghost" href={banner_cta_link} onClick={() => track({ event: event_name })}>
                    {banner_cta_text}
                  </CallToAction>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
